// import React, { useRef, useState } from 'react'
// import { useNavigate } from 'react-router-dom';
// import { FxRateAPI } from '../../@redux/Action/FX_Rate_Action';
// import { useDispatch, useSelector } from 'react-redux';

// function FXRateComponent() {
//     const fxRateValue = useSelector((state) => state.fxRate?.fxRateRes)
//     console.log("fxRateValue is ", fxRateValue)
//     const [fxRateQuery, setFxRateQuery] = useState({
//         'destination_currency': '',
//         'destination_amount': ''
//     });
//     //for error negative amount
//     const [error, setError] = useState('');
//     const dispatch = useDispatch();
//     const debounceTimer = useRef(null);

//     const debounce = (func, delay) => {
//         clearTimeout(debounceTimer.current);
//         debounceTimer.current = setTimeout(func, delay)
//     }

//     const handleOnChange = (e) => {
//         const { name, value } = e.target;
//         setFxRateQuery(prevState => ({
//             ...prevState,
//             [name]: value
//         }));

//         if (name === 'destination_amount') {
//             //for error negative amount
//             if (Number(value) < 0) {
//                 setError('Amount cannot be negative');
//             } else {
//                 setError('');
//                 debounce(() => {
//                     dispatch(FxRateAPI({
//                         ...fxRateQuery,
//                         [name]: value
//                     }));
//                 }, 1000);
//             }
//         }
//     };

//     const Navigate = useNavigate();

//     const handleProceed = (e) => {
//         e.preventDefault();
//         Navigate(`/onboarding`);
//     }

//     const formatNumber = (value) => {
//         if (value === undefined || value === null) {
//             return '';
//         }
//         return Number(value).toFixed(2);
//     }
//     return (
//         <div className="card bg-light shadow-sm rounded-4 px-2 pt-3">
//             <div className="card-body">
//                 <form onSubmit={handleProceed}>
//                     <div className="d-flex gap-2 mb-4">
//                         <select
//                             id="destination_currency"
//                             className="form-select border-0 shadow-sm"
//                             name="destination_currency"
//                             style={{
//                                 borderRadius: "8px",
//                                 backgroundColor: "#f8f9fa",
//                                 color: "#343a40",
//                             }}
//                             onChange={handleOnChange}
//                             value={fxRateQuery?.destination_currency}
//                             required
//                         >
//                             <option value="">Choose currency</option>
//                             <option value="USD">USD</option>
//                             <option value="AUD">AUD</option>
//                             <option value="SGD">SGD</option>
//                             <option value="CAD">CAD</option>
//                             <option value="GBP">GBP</option>
//                             <option value="EURO">EURO</option>
//                         </select>

//                         <input
//                             id="destination_amount"
//                             type="number"
//                             className="form-control border-0 shadow-sm"
//                             name="destination_amount"
//                             placeholder="Enter amount"
//                             style={{
//                                 borderRadius: "8px",
//                                 backgroundColor: "#f8f9fa",
//                                 color: "#343a40",
//                             }}
//                             value={fxRateQuery?.destination_amount}
//                             onChange={handleOnChange}
//                             disabled={!fxRateQuery?.destination_currency}
//                             required
//                         />
//                     </div>
//                     {/* for error negative amount */}
//                     {error && <div className="text-danger mb-3 text-center">{error}</div>}
//                     <div className="mb-4" >
//                         <div className="p-3 rounded-3 bg-white shadow-sm">
//                             <ul className="list-unstyled mb-0">
//                                 <li className="d-flex justify-content-between text-success fw-bold">
//                                     <span >
//                                         Exchange Rate:
//                                     </span>
//                                     <span
//                                         className="fw-semibold"
//                                         style={{ color: "#28a745" }}
//                                     >
//                                         {formatNumber(fxRateValue?.fx) || '0.00'}
//                                     </span>
//                                 </li>
//                                 <li className="d-flex justify-content-between mt-2 text-success fw-bold">
//                                     <span >Fees:</span>
//                                     <span
//                                         className="fw-semibold"
//                                         style={{ color: "#28a745" }}
//                                     >
//                                         {formatNumber(fxRateValue?.fees) || '0.00'}
//                                     </span>
//                                 </li>
//                                 <li className="d-flex justify-content-between mt-2 text-success fw-bold">
//                                     <span >TCS Rate:</span>
//                                     <span
//                                         className="fw-semibold"
//                                         style={{ color: "#28a745" }}
//                                     >
//                                         {formatNumber(fxRateValue?.tcs) || '0.00'}
//                                     </span>
//                                 </li>
//                             </ul>
//                         </div>
//                     </div>

//                     <div className="mb-4">

//                         <div className="input-group">
//                             <input
//                                 type="text"
//                                 className="form-control border-0 shadow-sm me-2"
//                                 value="INR"
//                                 disabled
//                                 style={{
//                                     borderRadius: "8px",
//                                     backgroundColor: "#f8f9fa",
//                                     color: "#343a40",
//                                 }}
//                             />
//                             <input
//                                 type="text"
//                                 className="form-control border-0 shadow-sm"
//                                 placeholder="Equivalent amount"
//                                 style={{
//                                     borderRadius: "8px",
//                                     backgroundColor: "#f8f9fa",
//                                     color: "#343a40",
//                                 }}
//                                 value={formatNumber(fxRateValue?.finalAmount) || '0.00'}
//                             />
//                         </div>
//                     </div>

//                     <div className="text-center">
//                         <button
//                             type="submit"
//                             className="btn btn-success px-4 py-2"
//                             style={{
//                                 borderRadius: "12px",
//                                 backgroundColor: "#28a745",
//                                 border: "none",
//                                 color: "#fff",
//                             }}
//                         >
//                             Proceed
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     )
// }

// export default FXRateComponent

//for static
import React from 'react';
import { useSelector } from 'react-redux';

function FXRateComponent() {
    const fxRateValue = useSelector((state) => state.fxRate?.fxRateRes);
    console.log("fxRateValue is ", fxRateValue);

    const formatNumber = (value) => {
        if (value === undefined || value === null) {
            return '';
        }
        return Number(value).toFixed(2);
    };

    return (
        <div className="card bg-light shadow-sm rounded-4 px-2 pt-3">
            <div className="card-body">
                <form>
                    <div className="d-flex gap-2 mb-4">
                        <select
                            id="destination_currency"
                            className="form-select border-0 shadow-sm"
                            name="destination_currency"
                            style={{
                                borderRadius: "8px",
                                backgroundColor: "#f8f9fa",
                                color: "#343a40",
                            }}
                            value=""
                            disabled
                        >
                            <option value="">Choose currency</option>
                            <option value="USD">USD</option>
                            <option value="AUD">AUD</option>
                            <option value="SGD">SGD</option>
                            <option value="CAD">CAD</option>
                            <option value="GBP">GBP</option>
                            <option value="EURO">EURO</option>
                        </select>

                        <input
                            id="destination_amount"
                            type="number"
                            className="form-control border-0 shadow-sm"
                            name="destination_amount"
                            placeholder="Enter amount"
                            style={{
                                borderRadius: "8px",
                                backgroundColor: "#f8f9fa",
                                color: "#343a40",
                            }}
                            value=""
                            disabled
                        />
                    </div>

                    <div className="mb-4">
                        <div className="p-3 rounded-3 bg-white shadow-sm">
                            <ul className="list-unstyled mb-0">
                                <li className="d-flex justify-content-between text-success fw-bold">
                                    <span>Exchange Rate:</span>
                                    <span
                                        className="fw-semibold"
                                        style={{ color: "#28a745" }}
                                    >
                                        {formatNumber(fxRateValue?.fx) || '0.00'}
                                    </span>
                                </li>
                                <li className="d-flex justify-content-between mt-2 text-success fw-bold">
                                    <span>Fees:</span>
                                    <span
                                        className="fw-semibold"
                                        style={{ color: "#28a745" }}
                                    >
                                        {formatNumber(fxRateValue?.fees) || '0.00'}
                                    </span>
                                </li>
                                <li className="d-flex justify-content-between mt-2 text-success fw-bold">
                                    <span>TCS Rate:</span>
                                    <span
                                        className="fw-semibold"
                                        style={{ color: "#28a745" }}
                                    >
                                        {formatNumber(fxRateValue?.tcs) || '0.00'}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="mb-4">
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control border-0 shadow-sm me-2"
                                value="INR"
                                disabled
                                style={{
                                    borderRadius: "8px",
                                    backgroundColor: "#f8f9fa",
                                    color: "#343a40",
                                }}
                            />
                            <input
                                type="text"
                                className="form-control border-0 shadow-sm"
                                placeholder="Equivalent amount"
                                style={{
                                    borderRadius: "8px",
                                    backgroundColor: "#f8f9fa",
                                    color: "#343a40",
                                }}
                                value={formatNumber(fxRateValue?.finalAmount) || '0.00'}
                                disabled
                            />
                        </div>
                    </div>

                    <div className="text-center">
                        <button
                            type="button"
                            className="btn btn-success px-4 py-2"
                            style={{
                                borderRadius: "12px",
                                backgroundColor: "#28a745",
                                border: "none",
                                color: "#fff",
                            }}
                            disabled
                        >
                            Proceed
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default FXRateComponent;
